<template>
    <div class="wordCloudView" v-loading="loading">
        <!-- 词云 -->
        <div class="title">词云大数据</div>
        <div ref='wordCloudBox'></div>
        <div class="hover-attribute" :style="attriStyle">
            <div class="attribute-circle" :style="{'background': fillColor}"></div>
            <span>{{attributeText}}</span>
            <span class="attribute-count">{{attributeCount}}</span>
        </div>
    </div>
</template>

<script>
import statisticsApi from '@/api/statistics'
import myCloud from './myCloud.js'

export default {
    name: 'wordCloudView',
    data () {
        return {
            wordList: [],
            attriStyle: {
                left: '269px',
                top: '584px',
                display: 'none'
            },
            attributeText: '',
            attributeCount: '',
            fillColor: 'rgb(0,0,0)',
            loading: false
        };
    },
    methods: {
        // 生成词云
        getWordCloud () {
            let that = this;
            this.loading = true;
            statisticsApi.getSubWordStatistic({
                type: 'book',
                libraryCode: this.global.getLibraryInfos().code
            })
            .then((response) => {
                that.loading = false;
                   for (let key in response.data) {
                    // console.log(key);
                    that.wordList.push({
                        text: key,
                        size: response.data[key]
                    });
                }
                if (that.wordList.length === 0) {
                    return;
                }
                let midSize = that.wordList[ parseInt(that.wordList.length / 2) ].size;
                for (let item of that.wordList) {
                    item.size = that.getWordSize(parseInt(item.size / midSize * 15))
                }
                let wordOption = {
                    wordList: that.wordList,
                    size: [752 * window.innerWidth / 1920, 450 * window.innerHeight / 1080], // 盒子的宽高
                    svgElement: this.$refs.wordCloudBox // 使用ref选择节点
                }
                // console.log(wordOption);
                myCloud(wordOption, this.textClick, this.showAttribute, this.textMouseMove, this.textMouseOut)
            });
        },
        textClick (text) {
            // 鼠标点击事件
            console.log(text);
            let routeUrl = this.$router.resolve({
                name: 'searchList',
				query: {
					keyWord: text
				}
            })
            window.open(routeUrl.href, '_blank')
        },
        getWordSize (size) {
            if (size > 20) {
                return 20;
            }
            if (size < 10) {
                return 10;
            }
            return size;
        },
        showAttribute (x, y, text, fillColor) {
            // console.log(x, y, text);
            let count = 0;
            for (let item of this.wordList) {
                if (item.text === text) {
                    count = item.size;
                    break;
                }
            }
            this.attributeText = text;
            this.attributeCount = count;
            this.attriStyle.left = (x + 20) + 'px';
            this.attriStyle.top = (y + 20) + 'px';
            this.fillColor = fillColor;
            this.attriStyle.border = 'solid 1px ' + fillColor;
            this.attriStyle.display = 'flex';
        },
        textMouseMove (x, y) {
            this.attriStyle.left = (x + 20) + 'px';
            this.attriStyle.top = (y + 20) + 'px';
        },
        textMouseOut () {
            this.attriStyle.display = 'none';
        }
    },
    mounted () {
        this.getWordCloud()
    }

  }
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.wordCloudView {
    width: 750 * @uw;
    height: 450 * @uw;
    position: relative;
    box-shadow: 0px 0px 10px 5px #e0e0e0;

    .title {
        font-size: 16 * @uw;
        color: #8d5e1a;
        margin: 0 * @uh 0px 20 * @uh 10 * @uw;
        padding-top: 10 * @uh;
    }

    .hover-attribute {
        position: absolute;
        width: auto;
        padding: 10px 20px 10px 20px;
        background: rgb(255, 255, 255);
        // color: white;
        border-radius: 5px;
        z-index: 1000;
        align-items: center;
        word-break: keep-all;
    }
    .attribute-circle {
        width: 12px;
        height: 12px;
        border-radius: 6px;
        margin-right: 10px;
    }
    .attribute-count {
        font-size: 15px;
        font-weight: bold;
        margin-left: 10 * @uw;
    }
}
</style>
